import { GlobalDesignGroupAction } from '../types';
import { groupByGroupDefinitions } from '../common/grouping/defaultGroupingStrategy';

export const filterGrouping: GlobalDesignGroupAction['grouping'] = {
  getGroupingStrategy: (editorPointers, getHost, componentsAPI) => {
    return () => {
      return groupByGroupDefinitions(
        editorPointers,
        'filterStyles',
        getHost,
        componentsAPI,
      );
    };
  },
};
